import axios from 'axios';

export function useLogout() {
  return async () => {
    try {
      const currentUrl = window.location.pathname;
      await axios.delete('/auth/logout.php');
      window.location.href = `/auth?success=${encodeURIComponent(currentUrl)}`;
    } catch (err) {
      console.error(err);
    }
  };
}
